document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('img');
  images.forEach((img) => {
    if (!img.alt) {
      Object.assign(img, { alt: '' });
    }
  });
});
